var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{class:{ ' yx-color-success': _vm.row.is_contact }},[_vm._v(_vm._s(_vm.row.is_contact ? '已' : '未')+"合作")])])
}
var staticRenderFns = []

export { render, staticRenderFns }